import React from 'react';
import { styled, keyframes } from '../../../theme/stitches.config';

const spinner = keyframes({
  to: {
    transform: 'rotate(360deg)',
  },
});

const Container = styled('div', {
  position: 'relative',
});

const Content = styled('div', {
  transition: 'opacity 0.3s ease-in-out',
});

const Loader = styled('div', {
  position: 'absolute',
  top: '50%',
  left: '50%',
  borderStyle: 'solid',
  borderRadius: '50%',
  animation: `${spinner} 1s linear infinite`,
  pointerEvents: 'none',
  zIndex: 2,
  width: '34px',
  height: '34px',
  color: 'var(--colors-pillActiveBackgroundColor)',
});

interface SMPOpacitorContainerProps {
  isLoading: boolean;
  children: React.ReactNode;
}

export const SMPOpacitorContainer: React.FC<SMPOpacitorContainerProps> = ({ isLoading, children }) => {
  return (
    <Container className='opacitor-container'>
      <Content style={{ opacity: isLoading ? 0.01 : 1 }}>{children}</Content>
      {isLoading && <Loader />}
    </Container>
  );
};
